<template>
  <div class="wrapper" v-if="screenType === 'mobile'">
    <div :class="['rounded-number', uploadStep >= currentStep && 'completed']">
      {{ uploadStep > currentStep ? '✓' : currentStep }}
    </div>
    <div :class="['title',isDarkMode && 'darkMode', uploadStep === currentStep && 'active-step']">
      {{ title }}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'StepForMobile',
  props: {
    screenType: String,
    title: String,
    currentStep: Number,
  },
  computed: {
    ...mapGetters(['uploadStep', 'isDarkMode']),
  },
}
</script>

<style scoped>
.wrapper {
  font-size: 1.25rem;
  font-weight: 500;
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  align-items: center;
  border-radius: 50%;
}
.rounded-number {
  background-color: rgba(0, 0, 0, 0.38);
  color: #fff;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-right: 10px;
  margin-left: 10px;
}
.title {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.38);
}
.darkMode {
  color: rgba(255, 255, 255, 0.38);
}
.active-step {
  color: inherit;
}
.completed {
  background-color: #2289dd;
}
</style>
